<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="6">
        <b-card>
          <div slot="header">
            <strong><i class="fa fa-align-justify"/> Créer un nouveau type produit</strong>
          </div>
          <b-form>
            <b-form-group label="Libellé court" label-for="libelleCourt">
              <b-form-input
                id="libelleCourt"
                type="text"
                :class="{hasError: errors.libelleCourt !== ''}"
                v-model="libelleCourt"
              />
              <span class="field-error">{{ errors.libelleCourt }}</span>
            </b-form-group>
            <b-form-group label="Libellé long" label-for="libelleLong">
              <b-form-input
                id="libelleLong"
                type="text"
                :class="{hasError: errors.libelleLong !== ''}"
                v-model="libelleLong">
              </b-form-input>
            </b-form-group>
            <div class="mt-5" slot="footer">
              <b-button type="button" @click="returnBack" size="md" variant="secondary">
                <i class="fa fa-arrow-left"/> Liste des types produit
              </b-button>
              <b-button type="button" @click="save" size="md" class="pull-right" variant="primary">
                <i class="fa fa-save"/> Enregistrer
              </b-button>
            </div>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import { getAccessToken, getBaseUrl, getIdToken, getProvider } from '@/utils/auth'
  import { isEmpty } from "@/utils/fileHelper"

  export default {
    name: "Add",
    data() {
      return {
        libelleCourt: "",
        libelleLong: "",
        errors: {
          libelleCourt: "",
          libelleLong: "",
        },
      }
    },
    created() {
      this.$axios.defaults.baseURL = getBaseUrl();
      this.$axios.defaults.headers.common["Authorization"] = getIdToken() + " " + getAccessToken();
      this.$axios.defaults.headers.common["Accept"] = "application/json";
      this.$axios.defaults.headers.common["Provider"] = getProvider();
    },
    methods: {
      save() {
        if (this.validateData()) {
          this.$store.commit("IS_LOADING", true);
          let dataPost = {};
          dataPost.libelleCourt = this.libelleCourt;
          dataPost.libelleLong = this.libelleLong;
          this.$axios
            .post("/espaceGestion/produit/gestion-type", dataPost)
            .then(() => {
              this.$store.commit("IS_LOADING", false);
              this.$swal({
                position: "top",
                type: "success",
                title: "Création avec succès",
                text: "Le type produit a été bien crée",
                showConfirmButton: false,
                timer: 5000
              });
              this.returnBack()
            })
            .catch(() => {
              this.$store.commit("IS_LOADING", false);
              this.handleError();
            });
        }
      },
      returnBack() {
        this.$router.push({path: "/espace-gestion/produit/gestion-type/list"});
      },
      validateData() {
        this.clearErrors()
        let valid = true;
        if (isEmpty(this.libelleCourt)) {
          this.errors.libelleCourt = "Le libellé court est obligatoire";
          valid = false;
        }
        else if (isEmpty(this.libelleLong)) {
          this.errors.libelleLong = "Le libellé long est obligatoire";
          valid = false;
        }
        return valid;
      },
      clearErrors() {
        this.errors.libelleCourt = "";
        this.errors.libelleLong = "";
      },
      handleError() {
        this.$swal({
          position: 'top',
          type: 'error',
          title: 'Attention !!',
          text: 'Un problème est survenu, merci de contacter l\'administrateur',
          showConfirmButton: false,
          timer: 5000
        });
      }
    }
  }
</script>
